<template>
  <div v-editable="blok" class="storyblok-carousel-item" @click="openLink">
    <StoryblokCard :blok="blok" :display-mode="displayMode" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { CommonRoutesName } from '@/router/constants/routesName';
import {
  extractStorySlugFromWardPath,
  resolveStoryblokLink,
} from '@/features/storyblok/utils/link';
import StoryblokCard from '@/features/storyblok/components/StoryblokCard.vue';
import type { StoryblokCardBlok } from '@/features/storyblok/types';

const router = useRouter();
const props = defineProps<{
  blok: StoryblokCardBlok;
  displayMode?: 'card' | 'slider';
}>();

const targetLink = computed(() => resolveStoryblokLink(props.blok.link, props.blok.linkType));
const openLink = () => {
  if (!targetLink.value) {
    return;
  }

  if (targetLink.value.type === 'external') {
    window.open(targetLink.value.href, '_blank', 'noopener,noreferrer');
    return;
  }

  if (targetLink.value.type === 'storyblok') {
    void router.replace({
      name: CommonRoutesName.StoryblokPage,
      query: { slug: targetLink.value.slug },
    });
    return;
  }

  const storySlugFromInternalPath = extractStorySlugFromWardPath(targetLink.value.path);
  if (storySlugFromInternalPath) {
    void router.replace({
      name: CommonRoutesName.StoryblokPage,
      query: { slug: storySlugFromInternalPath },
    });
    return;
  }

  void router.push(targetLink.value.path);
};
</script>

<style scoped>
.storyblok-carousel-item {
  width: 100%;
  height: 100%;
}

.storyblok-carousel-item :deep(.card) {
  margin: 0;
  height: 100%;
}

.storyblok-carousel-item :deep(.em-card) {
  height: 100%;
}
</style>
